import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'

import { getVaspProcessingStatusCounts } from '../ordersEndpoints'
import { ordersQueryKeys } from '../ordersQueryKeys'

interface Options {
  /**
   * Poll interval in ms, or false for no polling. Opt-in **per caller** because
   * AppSidebar subscribes to this same query app-wide for its badge: a baked-in
   * interval would poll on every page for every logged-in admin, forever.
   *
   * Both callers share one cache entry and TanStack takes the smallest interval
   * across observers, so passing this only from the queue page means the counts
   * poll while that page is mounted and stop entirely on navigate-away.
   */
  pollIntervalMs?: MaybeRefOrGetter<number | false>
}

export function useVaspProcessingStatusCountsQuery(options: Options = {}) {
  return useQuery({
    queryKey: ordersQueryKeys.vaspStatusCounts(),
    queryFn: getVaspProcessingStatusCounts,
    staleTime: 30_000,
    refetchInterval: () => toValue(options.pollIntervalMs) ?? false,
    refetchIntervalInBackground: false,
  })
}
